<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length === 0 ? "NONE" : "SEND"
        }}
        SMS
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- JOB TITLE -->
        <div class="vx-row">
          <div class="vx-col w-full">
           <vs-input label="Phone Number" v-model="phoneNumber" disabled size="default" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-textarea class="w-full mt-10" counter="160" label="SMS" rows="8"
            :counter-danger.sync="counterDanger" v-model="dataSms" />
            <span class="text-danger text-sm" v-show="errors.has('sms')">{{
              errors.first("sms")
            }}</span>
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      idsender: null,
      isadmin : false,
      type: Object,
      phoneNumber : "+40749234025",
      counterDanger: null,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
    "v-select": vSelect,
  },
  data() {
    return {
      dataSms: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      this.getOptionsPerson();
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
        this.dataId = null;
      } else {
        const { id,idpayslipsenders, employeename, generated_filename, phone } =
          JSON.parse(JSON.stringify(this.data));
        this.idsender = idpayslipsenders
        this.dataSms = employeename + ", Fluturaș: https://xylo.codesinn.com/web/payslipcode (COD: " + this.idsender + this.getFirstTwoLetters(employeename) + this.getLastTwoLetters(phone)+")";
        this.phoneNumber = phone
        const ItemIndex = this.data_options_person.findIndex(
          (p) => p.value === idperson
        );
        this.dataPerson = this.data_options_person.splice(ItemIndex, 1);
        
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          /*this.$validator.reset()
           this.initValues()*/
        }
      },
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    getFirstTwoLetters(name) {
      return name.slice(0, 2).toLowerCase();
    },
    getLastTwoLetters(name) {
      return name.slice(-2).toLowerCase();
    },
    changePermanent() {
      if (this.dataIsPermanent) this.dataIsPermanent = false;
      else this.dataIsPermanent = true;
    },
    async getOptionsPerson() {
      axios.get("/people_name/data").then((response) => {
        this.data_options_person = [...response.data];
      });
    },
    initValues() {
      (this.data_options_person = []),
        (this.dataPerson = "");
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Créer l'objet avec les données à envoyer
          const data = {
            to: this.phoneNumber.replace(/\s+/g, '') , // Assurez-vous que `phoneNumber` est défini dans votre data()
            smscontent: this.dataSms,   // Assurez-vous que `fileNumber` est défini dans votre data()
            payslipsenderid: this.idsender
          };

          // Envoyer les données avec Axios
          axios.post('/clicksend/createsms', data)
            .then(response => {
              // Traitement de la réponse
              console.log(response.data);
              alert("Données envoyées avec succès !");
              window.location.reload();
            })
            .catch(error => {
              // Gestion des erreurs
              console.error(error);
              alert("Erreur lors de l'envoi des données.");
            });
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) this.isadmin = true
    this.getOptionsPerson();
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
